import React from 'react';
import FileNodeRow from '../components/FileNodeRow';
import FolderNodeCollaps from '../components/FolderNodeCollaps';
import { NodeRowProps } from '../types';
import {
  DATA_ROOM_NODE_TYPE,
  DataRoomNodeType,
} from 'router/subrouters/DataRoom/models/DataRoomNode';

export const NODE_COMPONENT: Record<
  DataRoomNodeType,
  (val: NodeRowProps) => JSX.Element
> = {
  [DATA_ROOM_NODE_TYPE.FILE]: (props: NodeRowProps) => (
    <FileNodeRow {...props} />
  ),
  [DATA_ROOM_NODE_TYPE.FOLDER]: (props: NodeRowProps) => (
    <FolderNodeCollaps {...props} />
  ),
};
